import maplibre from 'maplibre-gl'

/**
 * Calculate the bounds of a set of locations.
 * @param locations The locations.
 * @returns The bounds.
 */
export default function calculateBounds(
    locations: maplibre.LngLat[]
): maplibre.LngLatBounds {
    return locations.reduce(
        (bounds, location) => bounds.extend(location),
        new maplibre.LngLatBounds()
    )
}
